/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:21:29
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-09-26 11:34:40
 * @FilePath: /vue_huaqiang/src/router/modules/report-management.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { RouteConfig } from "vue-router";
import Layout from "@/layout/index.vue";

const deliveryManagement: RouteConfig[] = [
  {
    path: "deliveryManagement",
    component: Layout,
    redirect: "deliveryManagement",
    name: "deliveryManagement",
    meta: {
      title: "deliveryManagement",
      icon: "el-icon-s-goods",
      alwaysShow: true,
    },
    children: [
      {
        path: "/factory-packing-list",
        component: () =>
            import("@/views/factory-packing-list/UploadFactoryPackingList.vue"),
        name: "UploadFactoryPackingList",
        meta: { title: "uploadFactoryPackingList" },
      },
      {
        path: "/hq-packing-list",
        component: () =>
            import("@/views/hq-packing-list-management/HqPackingList.vue"),
        name: "HqPackingListControl",
        meta: { title: "CustomerPackingListManagement" },
      },
      {
        path: "/supplierPaymentManagement",
        name: "supplierPaymentManagement",
        meta: { title: "supplierPaymentManagement" },
        component: () =>
          import("@/views-oms/financial-reconciliation-management/supplier-payment/index.vue")
      },
      {
        path: "/deliveryVerification",
        component: () =>
            import("@/views/hq-packing-list-management/delivery-verification/index.vue"),
        name: "deliveryVerification",
        meta: { title: "deliveryVerification" ,hidden:true,activeMenu:'/factory-packing-list'},
      },
      {
        path: ":type/:parentId/packing-list/:hqPackingListId/edit",
        name: "HqPackingListDetailForEdit",
        component: () =>
          import("@/views/inbound-management/HqPackingListDetailForEdit.vue"),
        meta: { title: "editHqPackingList", hidden: true }
      }
    ],
  }
]

export default deliveryManagement;
